export enum UserRole {
  student = 'STUDENT',
  teacher = 'TEACHER',
  admin = 'ADMIN',
}

export interface User {
  id: string;
  email: string;
  name: string;
  surname: string;
  role: UserRole;
  image: string;
}
